"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseAPIBody = void 0;
const camel_cast_1 = require("./camel-cast");
const resolveJsonMark_1 = require("./resolveJsonMark");
function transformIsoDate(value) {
    // 将 ISO String (如 "2021-01-26T12:28:17.000Z") 还原为日期对象
    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(value)) {
        return new Date(value);
    }
    return null;
}
function getJsonTransformer(cast) {
    const transformMarkedJson = (value) => {
        // 云 API 类型描述能力较弱，为了保留类型，将特复杂类型的字段用 json:// 前缀的方式序列化成 JSON
        const json = (0, resolveJsonMark_1.resolveMarkedJson)(value);
        if (json) {
            try {
                const obj = JSON.parse(json, transformer);
                if (cast) {
                    return (0, camel_cast_1.castCamelObject)(obj, cast);
                }
                return obj;
            }
            catch (_a) { }
        }
        return null;
    };
    const transformer = (key, value) => transformIsoDate(value) || transformMarkedJson(value) || value;
    return transformer;
}
function parseAPIBody(responseText, cast) {
    return JSON.parse(responseText, getJsonTransformer(cast));
}
exports.parseAPIBody = parseAPIBody;
